import { DIALECTS } from 'variables';
import { AllDialectOptions } from 'types/dialects';
import { isExclusivePronoun, type Pronoun } from 'domain/pronouns';

type ArePronounsSupportedByDialectProps = {
  dialect: AllDialectOptions;
  pronoun?: Pronoun;
};

const isPronounSupportedByDialect = ({
  dialect,
  pronoun,
}: ArePronounsSupportedByDialectProps): boolean => {
  if (isExclusivePronoun(pronoun)) {
    return true;
  }

  return DIALECTS[dialect]?.supportsInclusivePronouns || false;
};

export default isPronounSupportedByDialect;
